import { I18n } from 'react-redux-i18n';

const entitySearchFields = (searchFieldValues, parentList) => {
    return {
        rows: [{
            hasTopBreak: false,
            hasBottomBreak: false,
            fields: [{
                id: "name",
                label: I18n.t("entities.list.name"),
                type: "text",
                value: searchFieldValues.name.value,
            }, {
                id: "parentId",
                label: I18n.t("entities.list.parent"),
                type: "dropdown",
                value: searchFieldValues.parentId.value,
                data: parentList,
            }, {
                id: "type",
                label: I18n.t("entities.list.type"),
                type: "dropdown",
                value: searchFieldValues.type.value,
                data: searchFieldValues.type.data,
            }]
        }]
    }
};

export {
    entitySearchFields
}